module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_03_american-village-a040d2af11b79a7141d0f2f0afb46fc6.jpg";